import { MarketAsset } from "./market-asset";

export type MarketAssetUserState = typeof MarketAssetUserState.Type;
export type MarketAssetUserStateEncoded = typeof MarketAssetUserState.Encoded;

export const MarketAssetUserState = MarketAsset.pick(
  "tokenBalance",
  "collateralBalance",
  "protectedBalance",
  "debtBalance",
  "projectedDebtBalance"
).annotations({ identifier: "MarketAssetUserState" });
